<template>
    <div
        class="cabinet-nav cabinet-nav--supplier cabinet-nav--public flex flex-justify-sb"
    >
        <div class="cabinet-nav__header">
            <div class="flex flex-align-center">
                <i
                    class="cabinet-nav__icon cabinet-nav__icon--group-ellipse"
                ></i>
                <router-link
                    to="/account"
                    class="cabinet-nav__logo--goldnet-market"
                ></router-link>
            </div>
            <div class="cabinet-nav__header-label">Кабинет поставщика</div>
        </div>

        <div class="cabinet-nav-links">
            <nav-body />
        </div>

        <div
            v-click-outside="userSubMenuClose"
            :class="{ open: userSubMenuIsOpen }"
            class="cabinet-nav-footer cabinet-nav-footer--public flex flex-justify-sb flex-align-center js-dropdown-toogle d-none d-md-flex"
            @click="userSubMenuToggle"
        >
            <a
                href="javascript:void(0)"
                class="cabinet-nav-footer__link cabinet-nav-footer__link--user flex flex-align-center"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--user"></i>
                <div class="cabinet-nav-footer__link-title">
                    {{ user ? user.LoginName : '' }}
                </div>
            </a>
            <div
                :class="{ open: userSubMenuIsOpen }"
                class="cabinet-nav-footer__arrow"
            ></div>

            <div
                :class="{ hide: !userSubMenuIsOpen }"
                class="app-dropdown app-dropdown--nav js-dropdown"
            >
                <div class="app-dropdown__main-menu">
                    <router-link
                        to="/account/statistics"
                        exact
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--statistics"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Статистика
                        </div>
                    </router-link>
                    <router-link
                        to="/account/statistics/suppliers"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--users"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Поставщики
                        </div>
                    </router-link>
                    <router-link
                        to="/account/statistics/retailers"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--users"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Ритейлеры
                        </div>
                    </router-link>
                    <router-link
                        to="/"
                        exact
                        target="_blank"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center"
                    >
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Маркетплейс
                        </div>
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--marketplace"
                        ></i>
                    </router-link>
                </div>
                <router-link to="/account/settings" class="app-dropdown__item"
                    >Настройки аккаунта</router-link
                >

                <a href="/auth/logout" class="app-dropdown__item">
                    Выйти
                </a>
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item js-modal-toogle d-md-none"
                    @click.prevent="openModal"
                    >Помощь</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ClickOutside from 'vue-click-outside'
import settings from '@/settings'
import NavBody from './Supplier'

export default {
    name: 'SupplierNav',
    components: {
        NavBody
    },
    directives: {
        ClickOutside
    },
    data() {
        return {
            userSubMenuIsOpen: false,
            canLogout: !settings.IS_DEV_MODE
        }
    },
    computed: {
        ...mapGetters('user', ['isSupplier']),
        ...mapState('user', ['user'])
    },
    methods: {
        ...mapMutations('user', ['DELETE_USER']),
        ...mapMutations('help', ['SET_MODAL_TIMESTAMP']),
        userSubMenuToggle() {
            this.userSubMenuIsOpen = !this.userSubMenuIsOpen
        },
        userSubMenuOpen() {
            this.userSubMenuIsOpen = true
        },
        userSubMenuClose() {
            this.userSubMenuIsOpen = false
        },
        openModal() {
            this.SET_MODAL_TIMESTAMP('' + Date.now())
        }
    }
}
</script>
